import { css } from '@emotion/css';

export const imagePixelatedStyle = css({
  imageRendering: 'pixelated'
});
